import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, NativeSelect, FormLabel } from "@mui/material";
import { MdKeyboardArrowDown } from "react-icons/md";
import { PALETTE } from "../Theme/Palette";

//todo: qsmt error byd handle beshe
function Select({
  label,
  value,
  id,
  name,
  data = [],
  error = false,
  labelKey = "name",
  idKey = "id",
  disabled = false,
  flex,
  labelFlex,
  haveEmptyOption = true,
  onChange = () => {},
}) {
  const [showSubmitError, setShowSubmitError] = useState(
    (!value || value === undefined || value === "") && error
  );

  useEffect(() => {
    setShowSubmitError((!value || value === undefined || value === "") && error);
  }, [error, value]);

  return (
    <FormControl
      disabled={disabled}
      sx={{
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
      }}
    >
      {label && (
        <FormLabel
          htmlFor={id}
          sx={{
            flex: labelFlex,
            textAlign: "right",
            color: "#4C466F !important",
            fontSize: 14,
          }}
        >
          {label}
        </FormLabel>
      )}
      <NativeSelect
        onChange={onChange}
        value={value ?? ""}
        IconComponent={MdKeyboardArrowDown}
        disableUnderline
        id={id}
        name={name}
        sx={{
          height: "40px",
          color: PALETTE.third + " !important",
          flex,
          fontWeight: "bold",
          marginTop: "0px !important",
          bgcolor: !disabled ? PALETTE.primary : PALETTE.fifth,
          textAlign: "right",
          borderRadius: 2,
          direction: "rtl",
          fontSize: 14,
          border: `1px solid ${
            disabled ? "transparent" : showSubmitError ? PALETTE.ninth : PALETTE.fourth
          }`,
          "& select": {
            paddingRight: "0.7rem !important",
          },
          "& svg": {
            fontSize: "1.4rem",
            display: disabled && "none",
            right: "100% !important",
            left: "0px !important",
            top: "50% !important",
            transform: "translate(115%,-50%) !important",
          },
          "& :disabled , & .Mui-disabled": {
            WebkitTextFillColor: PALETTE.sixth,
            color: PALETTE.sixth,
            backgroundColor: PALETTE.fifth,
            border: "1px solid transparent !important",
          },
        }}
      >
        {haveEmptyOption && <option value=""></option>}
        {data.map((item) => (
          <option
            value={item[idKey]}
            key={item[idKey]}
            style={{ color: PALETTE.third, fontWeight: "bold" }}
          >
            {item[labelKey]}
          </option>
        ))}
      </NativeSelect>
    </FormControl>
  );
}

Select.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  data: PropTypes.array,
  labelKey: PropTypes.string,
  idKey: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Select;
